// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gs","advertCardList_max6":"c-a_gt"};